export default __webpack_public_path__ + "static/media/v2_266.f6226df0.png";